import {
  StaffPayrollPeriodRequest,
  StaffPayrollPeriodResponse,
  StaffPayrollRunResponse,
  StaffPayslipLineResponse,
  StaffPayslipRequest,
  StaffPayslipResponse,
} from "lib-klab-sdks";
import {
  PayrollPeriod,
  PayrollPeriodRequest,
  PayrollRun,
  Payslip,
  PayslipLine,
  PayslipRequest,
} from "../../../domain/models/payroll/payroll.model";

export function mapPayrollPeriod(source: StaffPayrollPeriodResponse): PayrollPeriod {
  return {
    id: source.payrollPeriodId,
    companyId: source.companyId,
    year: source.year,
    month: source.month,
    startDate: source.startDate,
    endDate: source.endDate,
    status: source.status,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
  };
}

export function mapPayslipLine(source: StaffPayslipLineResponse): PayslipLine {
  return {
    id: source.payslipLineId,
    lineType: source.lineType,
    code: source.code,
    name: source.name,
    quantity: source.quantity == null ? null : Number(source.quantity),
    rate: source.rate == null ? null : Number(source.rate),
    amount: Number(source.amount),
    sortOrder: source.sortOrder,
  };
}

export function mapPayslip(source: StaffPayslipResponse): Payslip {
  return {
    id: source.payslipId,
    payrollPeriodId: source.payrollPeriodId,
    companyId: source.companyId,
    employeeId: source.employeeId,
    employeeCode: source.employeeCode,
    documentNumber: source.documentNumber,
    employeeName: source.employeeName,
    currencyCode: source.currencyCode,
    grossAmount: Number(source.grossAmount),
    deductionAmount: Number(source.deductionAmount),
    netAmount: Number(source.netAmount),
    status: source.status,
    documentUrl: source.documentUrl,
    issuedAt: source.issuedAt,
    signedByUserId: source.signedByUserId,
    signedAt: source.signedAt,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
    lines: (source.lines ?? []).map(mapPayslipLine),
  };
}

export function mapPayrollRun(source: StaffPayrollRunResponse): PayrollRun {
  return {
    period: mapPayrollPeriod(source.period),
    payslips: (source.payslips ?? []).map(mapPayslip),
  };
}

export function mapPayrollPeriodRequest(
  source: PayrollPeriodRequest,
): StaffPayrollPeriodRequest {
  return { ...source };
}

export function mapPayslipRequest(source: PayslipRequest): StaffPayslipRequest {
  return {
    ...source,
    lines: source.lines.map((line) => ({ ...line })),
  };
}
